/* =========================================================
   Sawickipedia Marine Theme — Main JS
   ========================================================= */

document.addEventListener('DOMContentLoaded', function () {

  // ── Cart Drawer ────────────────────────────────────────
  const cartDrawer  = document.getElementById('cartDrawer');
  const cartOverlay = document.getElementById('cartOverlay');
  const cartToggle  = document.getElementById('cartToggle');
  const cartClose   = document.getElementById('cartClose');
  const cartContinue = document.getElementById('cartContinue');

  function openCart() {
    cartDrawer && cartDrawer.classList.add('open');
    cartOverlay && cartOverlay.classList.add('open');
    document.body.style.overflow = 'hidden';
  }

  function closeCart() {
    cartDrawer && cartDrawer.classList.remove('open');
    cartOverlay && cartOverlay.classList.remove('open');
    document.body.style.overflow = '';
  }

  cartToggle   && cartToggle.addEventListener('click', openCart);
  cartClose    && cartClose.addEventListener('click', closeCart);
  cartContinue && cartContinue.addEventListener('click', closeCart);
  cartOverlay  && cartOverlay.addEventListener('click', closeCart);

  // ── Quick Add to Cart ─────────────────────────────────
  document.querySelectorAll('.product-card-quick-add').forEach(btn => {
    btn.addEventListener('click', async function (e) {
      e.preventDefault();
      const variantId = this.dataset.variantId;
      if (!variantId) return;

      const originalText = this.innerHTML;
      this.innerHTML = 'Adding…';
      this.disabled = true;

      try {
        const resp = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 }),
        });

        if (resp.ok) {
          await updateCartCount();
          this.innerHTML = '✓ Added!';
          setTimeout(() => {
            this.innerHTML = originalText;
            this.disabled = false;
          }, 1800);
          openCart();
          await refreshCartDrawer();
        } else {
          throw new Error('Add to cart failed');
        }
      } catch (err) {
        this.innerHTML = 'Error — try again';
        this.disabled = false;
        console.error(err);
      }
    });
  });

  // ── Add-to-Cart Form (product page) ──────────────────
  const addToCartForm = document.getElementById('addToCartForm');
  if (addToCartForm) {
    addToCartForm.addEventListener('submit', async function (e) {
      e.preventDefault();
      const btn = document.getElementById('addToCartBtn');
      const variantId = document.getElementById('variantId').value;
      const qty = document.getElementById('qtyInput').value;

      const originalHTML = btn.innerHTML;
      btn.innerHTML = 'Adding…';
      btn.disabled = true;

      try {
        const resp = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: parseInt(qty) }),
        });

        if (resp.ok) {
          await updateCartCount();
          btn.innerHTML = '✓ Added to Cart!';
          openCart();
          await refreshCartDrawer();
          setTimeout(() => { btn.innerHTML = originalHTML; btn.disabled = false; }, 2000);
        } else {
          throw new Error();
        }
      } catch {
        btn.innerHTML = 'Error — please try again';
        btn.disabled = false;
      }
    });
  }

  // ── Cart Item Remove (drawer) ─────────────────────────
  document.querySelectorAll('.cart-item-remove').forEach(btn => {
    btn.addEventListener('click', async function () {
      const key = this.dataset.key;
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: 0 }),
      });
      await updateCartCount();
      await refreshCartDrawer();
    });
  });

  // ── Update Cart Count ─────────────────────────────────
  async function updateCartCount() {
    try {
      const resp = await fetch('/cart.js');
      const cart = await resp.json();
      const countEl = document.getElementById('cartCount');
      if (countEl) countEl.textContent = cart.item_count;
    } catch (e) { /* silent */ }
  }

  // ── Refresh Cart Drawer HTML ──────────────────────────
  async function refreshCartDrawer() {
    try {
      const resp = await fetch('/?section_id=cart-drawer');
      if (!resp.ok) return;
      const html = await resp.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const newDrawer = doc.getElementById('cartDrawer');
      if (newDrawer && cartDrawer) {
        cartDrawer.innerHTML = newDrawer.innerHTML;
        // Re-attach remove listeners
        cartDrawer.querySelectorAll('.cart-item-remove').forEach(btn => {
          btn.addEventListener('click', async function () {
            await fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: this.dataset.key, quantity: 0 }),
            });
            await updateCartCount();
            await refreshCartDrawer();
          });
        });
      }
    } catch (e) { /* silent */ }
  }

  // ── Mobile Menu ───────────────────────────────────────
  const mobileMenuBtn = document.getElementById('mobileMenuBtn');
  const mobileNav     = document.getElementById('mobileNav');
  if (mobileMenuBtn && mobileNav) {
    mobileMenuBtn.addEventListener('click', () => {
      mobileNav.classList.toggle('open');
    });
  }

  // ── Announcement Bar Dismiss ──────────────────────────
  const announcementBar = document.querySelector('.announcement-bar');
  if (announcementBar) {
    announcementBar.style.cursor = 'pointer';
    announcementBar.title = 'Click to dismiss';
    announcementBar.addEventListener('click', () => {
      announcementBar.style.display = 'none';
    });
  }

});
